import { ChangeEvent, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Card, CardBody, Col, Form } from 'reactstrap';
import { useForm } from 'react-hook-form';
import { DeleteLessonForm } from '../../../../../types/Forms';
import PreMigrationStepForm from './PreMigrationStep';
import MigrationStepForm from './MigrationStep';
import FinalStepForm from './FinalStep';
import { LessonWithRelationsToDelete } from '../../../../../types/Courses';
import { useTranslation } from 'react-i18next';
import { set } from 'video.js/dist/types/tech/middleware';
import { useMigrateLessonMutation } from '../../../../../reduxToolkit/reducers/usersSlice';
import { cl } from '@fullcalendar/core/internal-common';

const LessonDeleteConfirmationForm = ({
  deleteLesson,
  handleDelete,
  close,
}: {
    deleteLesson: LessonWithRelationsToDelete;
    handleDelete: (formData: DeleteLessonForm) => void;
    close: () => void;
}) => {
  const [step, setStep] = useState(1);
  const [showSubmit, setShowSubmit] = useState(false);
  const {
    register,
    formState: { errors },
    setValue,
    watch,
    trigger,
  } = useForm<DeleteLessonForm>({});

 
  const formData = watch(); // Store watched values so that they persist between steps
  const { t } = useTranslation();
  useEffect(() => {
    console.log('deleteLesson', deleteLesson);
    setValue('lessonToDeleteId', deleteLesson.lessonId);
    setValue('deleteVideo', true);
    setValue('migrateToLessonId', null);
    setValue('migrateToLesson', null);
  }, [deleteLesson, setValue]);
  const handleSubmitButton = () => {
    handleDelete(formData);
    close();
  };
  const updateFormData = (
    eventOrPayload: ChangeEvent<HTMLInputElement> | { name: string; value: any },
  ) => {
    let name: string;
    let value: any;
    if ((eventOrPayload as any).target) {
      const ev = eventOrPayload as ChangeEvent<HTMLInputElement>;
      name = ev.target.name;
      if (ev.target.type === 'checkbox') value = ev.target.checked;
      else value = ev.target.value || '';
    } else {
      const p = eventOrPayload as { name: string; value: any };
      name = p.name;
      value = p.value;
    }

    setValue(name as keyof DeleteLessonForm, value, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  const handleNextButton = async () => {
    setStep((prevStep) => prevStep + 1);
    if (step === 2) setShowSubmit(true);
  };

  const handleBackButton = () => {
    setShowSubmit(false);
    setStep((prev) => prev - 1);
  };
  return (
    <Col sm="12">
      <Card>
        {/* <CommonCardHeader title={StudentValidationFormTitle} span={StudentValidationFormSubTitle} /> */}
        <CardBody className="custom-input">
          <Form className="form-wizard" onSubmit={(e) => e.preventDefault()}>
            <div className={`tab ${step === 1 ? 'd-block' : 'd-none'}`}>
              <PreMigrationStepForm
                register={register}
                errors={errors}
                formData={formData}
                updateFormData={updateFormData}
                lessionTitle={deleteLesson.lessonTitle}
              />
            </div>
            <div className={`tab ${step === 2 ? 'd-block' : 'd-none'}`}>
              <MigrationStepForm
                register={register}
                errors={errors}
                formData={formData}
                updateFormData={updateFormData}
                lessionTitle={deleteLesson.lessonTitle}
                courseId={deleteLesson.courseId}
              />
            </div>

            {step === 3 && <FinalStepForm formData={formData} deleteLesson={deleteLesson} />}
            <div className="text-end pt-3">
              {step > 1 && (
                <Button color="secondary" className="me-1" onClick={handleBackButton}>
                  {t('global.back')}
                </Button>
              )}
              <Button color="primary" onClick={showSubmit ? handleSubmitButton : handleNextButton}>
                {showSubmit ? t('global.delete') : t('global.next')}
              </Button>
            </div>
            <div className="text-center">
              <span className={`step ${step === 1 ? 'active' : ''}`} />
              <span className={`step ${step === 2 ? 'active' : ''}`} />
              <span className={`step ${step === 3 ? 'active' : ''}`} />
            </div>
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
};

export default LessonDeleteConfirmationForm;
